import { icon, Symbol as LeafletSymbol, polylineDecorator } from "leaflet";
import React, { useEffect, useRef, useState } from "react";
import { Polyline, useMap } from "react-leaflet";
import "leaflet-polylinedecorator";

const arrowPattern = (arrowColor) => [
    {
        repeat: 150,
        symbol: LeafletSymbol.marker({
            rotate: true,
            markerOptions: {
                icon: icon({
                    iconUrl: `/images/icons/arrow-${arrowColor}.svg`,
                    iconAnchor: [12, 10],
                    iconSize: [24, 20],
                }),
            },
        }),
    },
];

const PolylineDecorator = (props) => {
    const polyRef = useRef();
    const map = useMap();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => {
            decorator?.remove();
        };
    }, []);

    useEffect(() => {
        if (!mounted) {
            return;
        }
        polyRef.current.setStyle({ color: props.color });
    }, [props.color]);

    const decorator = polylineDecorator(polyRef.current, {
        patterns: arrowPattern(props.arrowColor),
    }).on("mouseout", () => {
        decorator?.remove();
    });

    const polylineProps = {
        eventHandlers: {
            mouseover: () => {
                const polyline = polyRef.current;
                polyline.removeEventListener("mouseout");
                decorator?.addTo(map);
                setTimeout(() => {
                    polyline.addEventListener("mouseout", () => {
                        decorator?.remove();
                    });
                }, 0);
            },
        },
    };

    return <Polyline ref={polyRef} {...props} {...polylineProps} />;
};

export default PolylineDecorator;
